import { toast } from 'react-toastify';

const errorToast = (message: string) => {
  console.error(message, 'messageesees')
  toast(message, { type: 'error', position: 'top-left', theme: 'colored' });
};

const successToast = (message: string) => {
  toast(message, { type: 'success', position: 'top-left', theme: 'colored' });
};

export { errorToast, successToast };
